import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaBars, FaUser, FaKey, FaSignOutAlt } from "react-icons/fa";
import { toast } from "react-toastify";
import { logout } from "../../services/authService";

export default function Header({ toggleSidebar }) {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      const response = await logout();
      console.log("Logout Response:", response);
      toast.success("User logged out successfully");
      navigate("/");
    } catch (error) {
      console.error("Logout Error:", error);
      toast.error("Logout failed");
    }
  };

  const handleProfile = () => {
    navigate("/admin/schoolinfo");
  };

  const handleChangePassword = () => {
    navigate("/admin/changepassword");
  };


  return (
    <>
      <style>{`
        .header-bar {
          height: 70px;
          background: #0b1a4a;
          color: #fff;
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 0 20px;
          position: sticky;
          top: 0;
          z-index: 100;
        }

        .left-section {
          display: flex;
          align-items: center;
          gap: 10px;
        }

        .toggle-btn {
          font-size: 20px;
          cursor: pointer;
        }

        .admin-box {
          position: relative;
          cursor: pointer;
        }

        .dropdown {
          position: absolute;
          top: 40px;
          right: 0;
          background: #0b1a4a;
          border: 1px solid #ddd;
          width: 180px;
          border-radius: 5px;
          overflow: hidden;
        }

        .dropdown-item {
          padding: 10px;
          display: flex;
          align-items: center;
          gap: 10px;
          cursor: pointer;
        }

        .dropdown-item:hover {
          background: #142a7a;
        }

        @media (min-width: 1200px) {
        .h2, h2 {
        font-size: 1.4rem;
    }
}
      `}</style>

      <div className="header-bar">
        <div className="left-section">
          <FaBars className="toggle-btn" onClick={toggleSidebar} />
          <h2>School Management System</h2>
        </div>

        <div className="admin-box" onClick={() => setOpen(!open)}>
          Admin ▾

          {open && (
            <div className="dropdown">
              <div
                className="dropdown-item"
                onClick={(e) => {
                  e.stopPropagation();
                  handleProfile();
                }}
              >
                <FaUser /> Profile
              </div>

              <div
                className="dropdown-item"
                onClick={(e) => {
                  e.stopPropagation();
                  handleChangePassword();
                }}
              >
                <FaKey /> Change Password
              </div>

              <div
                className="dropdown-item"
                onClick={(e) => {
                  e.stopPropagation();
                  handleLogout();
                }}
              >
                <FaSignOutAlt /> Logout
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
}